var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5137,
    cy: 24.5,
    r: 22.3047,
    stroke: "white",
    strokeWidth: 4.3906
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6204 8.27278C27.198 8.27278 29.739 8.88282 32.0356 10.053C34.3323 11.2232 36.3193 12.9203 37.8344 15.0056C39.3494 17.0909 40.3495 19.5052 40.7527 22.051C41.1559 24.5969 40.9509 27.202 40.1544 29.6534C39.3579 32.1048 37.9925 34.3329 36.1699 36.1555C34.3472 37.9781 32.1191 39.3435 29.6677 40.14C27.2163 40.9366 24.6112 41.1416 22.0653 40.7384C19.5195 40.3351 17.1052 39.3351 15.0199 37.8201L24.6204 24.6061L24.6204 8.27278Z",
    fill: "#F2CA88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeF);
export default __webpack_public_path__ + "static/media/typeF.f4e2bb8ec51e0e67700dcd35f7a44adb.svg";
export { ForwardRef as ReactComponent };